<section class="px-4 websites_managment">
  <!-- Loader -->
  <div
    class="d-flex flex-column align-items-center justify-content-center"
    *ngIf="loading"
  >
    <mat-spinner diameter="56"></mat-spinner>
    <span>Loading content...</span>
  </div>

  <!-- Error -->
  <div *ngIf="!loading && errorMsg" class="error">
    <mat-icon>error_outline</mat-icon>
    {{ errorMsg }}
    <button translate mat-stroked-button (click)="getPagesByWebsiteId()">
      Retry
    </button>
  </div>

  <!-- Content -->
  <ng-container *ngIf="!loading && !errorMsg">
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <button class="back_icon me-2" (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <h1 translate class="m-0 page_header_title">Page List</h1>
      </div>
      <div *ngIf="actiondata?.create">
        <button
          translate
          mat-raised-button
          color="primary"
          (click)="openAddPageDialog()"
          class="px-5 add_button"
        >
          Add Pages
        </button>
      </div>
    </div>

    <div class="page-name-list-container list-container mt-3">
      <div
        *ngIf="pages?.length === 0"
        class="empty-data list-container d-flex flex-column justify-content-center align-items-center"
      >
        <i class="fa-solid fa-inbox empty-icon"></i>
        <p translate>No Data found</p>
      </div>

      <div *ngIf="pages && pages.length > 0" class="page-cards-container">
        <mat-card
          *ngFor="let page of pages"
          class="page-card card_container_upper"
        >
          <!-- (click)="viewPageComponents(page.id) -->
          <div class="card-header">
            <div class="title-section">
              <h3 class="website-title">{{ page.name }}</h3>
            </div>
            <!-- <button
              mat-icon-button
              [matMenuTriggerFor]="pageMenu"
              aria-label="Page actions menu"
              (click)="$event.stopPropagation()"
            >
            <i class="fa-solid fa-ellipsis-vertical"></i>
            </button> -->
            <div
              class="action_button cursor_pointer"
              [matMenuTriggerFor]="pageMenu"
              aria-label="Page actions menu"
              (click)="$event.stopPropagation()"
            >
              <i class="text_color fa-solid fa-ellipsis-vertical"></i>
            </div>

            <mat-menu #pageMenu="matMenu">
              <p
                class="m-0"
                mat-menu-item
                (click)="viewPageComponents(page.id)"
              >
                <span translate>View Page Components</span>
              </p>
              <p
                class="m-0"
                mat-menu-item
                (click)="openEditPageNameDialog(page)"
              >
                <span translate>Edit Page</span>
              </p>
              <p class="m-0" mat-menu-item (click)="deletePage(page.id)">
                <span translate>Delete Page</span>
              </p>
            </mat-menu>
          </div>

          <mat-card-content>
            <p>{{ page.description }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </ng-container>
</section>
